import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const CheckFilledCircleIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M18.75 9.75C18.75 14.7206 14.7206 18.75 9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75C14.7206 0.75 18.75 4.77944 18.75 9.75Z"
      fill="#389E0D"
    />
    <path
      d="M5.7 9.75L8.4 12.45L13.8 7.05"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
